import { logEvent } from 'firebase/analytics';
import { getAnalyticsInstance } from '../firebase';

/**
 * Safe wrapper around Firebase Analytics logEvent.
 * No-ops if analytics hasn't initialized yet (ad blockers, SSR, unsupported browsers).
 *
 * @param {string} eventName - GA4 event name (snake_case)
 * @param {Record<string, unknown>} [params]
 */
export function logAnalyticsEvent(eventName, params = {}) {
  const instance = getAnalyticsInstance();
  if (!instance) return;
  try {
    logEvent(instance, eventName, params);
  } catch {
    // Silently ignore — analytics should never break the app
  }
}
